import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
import { environment } from '../../../../environments/environment';
import { isNull } from 'util';
const HEADERS = {};

@Injectable()
export class MagneticMediaDistrictService {
  static ENV = environment;
  constructor(private httpService: HttpService) { }

  public getLoockupValueByType(data:any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MagneticMediaDistrictService.ENV.environment.API.loockup_value_view}/${data.type}/${data.code}`, httpRequesthandler);
  }

  public articleSave(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.article_save}`, data,  httpRequesthandler);
  }

  public getYearsByArticle(ledger_id: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MagneticMediaDistrictService.ENV.environment.API.years_article}/${ledger_id}`,  httpRequesthandler);
  }

  public getArticlesByLedgers(data: any ,httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MagneticMediaDistrictService.ENV.environment.API.article_save}/${data.ledger}/${data.year}`,  httpRequesthandler);
  }
  public getArticleDetail(data: any ,httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MagneticMediaDistrictService.ENV.environment.API.article_detail}/${data.article}`,  httpRequesthandler);
  }

  public deleteArticleCols(article_col_id: any ,httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${MagneticMediaDistrictService.ENV.environment.API.article_detail_delete}/${article_col_id}`,  httpRequesthandler);
  }

  public saveArticleDetails(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.article_detail}`, data,  httpRequesthandler);
  }
  public updateArticleDetails(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(`${MagneticMediaDistrictService.ENV.environment.API.article_detail}`, data,  httpRequesthandler);
  }

  public getListArticleValue(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MagneticMediaDistrictService.ENV.environment.API.article_value}/${data.article}`,  httpRequesthandler);
  }

  public ArticleValueDetail(detail_id: any ,httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${MagneticMediaDistrictService.ENV.environment.API.article_value_delete}/${detail_id}`,  httpRequesthandler);
  }

  public saveArticleValueDetails(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.article_value}`, data,  httpRequesthandler);
  }

  public updateArticleValueDetails(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(`${MagneticMediaDistrictService.ENV.environment.API.article_value}`, data,  httpRequesthandler);
  }

  public getListArticleRange(detail_id: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MagneticMediaDistrictService.ENV.environment.API.article_range}/${detail_id}`,  httpRequesthandler);
  }

  public ArticleRangeDetail(range_id: any ,httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${MagneticMediaDistrictService.ENV.environment.API.article_range_delete}/${range_id}`,  httpRequesthandler);
  }

  public saveArticleRangeDetails(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.article_range}`, data,  httpRequesthandler);
  }

  public updateArticleRangeDetails(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(`${MagneticMediaDistrictService.ENV.environment.API.article_range}`, data,  httpRequesthandler);
  }

  public generateMagneticMediaDistric(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.genertation_media_district}`, data,  httpRequesthandler);
  }
  public genertationArticleCsv(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.genertation_article_csv}`, data,  httpRequesthandler);
  }
  public validationAcountThird(data: any, httpRequesthandler: HttpRequestHandler): void {
      httpRequesthandler.headers = HEADERS;
      this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.validation_acount_third}`, data,  httpRequesthandler);
  }
  public f_article_copy(data, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.f_article_copy}`, data, httpRequesthandler);
  }

  public getReportArticleDetails(data: any, httpRequesthandler: HttpRequestHandler): void {
      httpRequesthandler.headers = HEADERS;
      this.httpService.post(`${MagneticMediaDistrictService.ENV.environment.API.report_article_details}`, data,  httpRequesthandler);
  }




  public getListArticles(type: any): Promise<any> {
    let listArcticle = [];
    return new Promise<any>((resolve, reject) => {
      this.getLoockupValueByType(type, {
        success: (response) => {
          listArcticle = response.data.map((item) => {
            const itemNew = Object.assign({}, item)
            itemNew.id =  item.lookup_value;
            itemNew.name = item.meaning;
            return itemNew
          });
          resolve(listArcticle)
        },
        error: (e) => {
          reject(listArcticle)
        }
      })
    });
  }

  public getListLoocupValue(data: any): Promise<any> {
    let listArcticle = [];
    return new Promise<any>((resolve, reject) => {
      this.getLoockupValueByType(data, {
        success: (response) => {
          listArcticle = response.data.map((item) => {
            const itemNew = Object.assign({}, item)
            itemNew.id =  item.lookup_value;
            itemNew.name = item.meaning;
            return itemNew
          });
          resolve(listArcticle)
        },
        error: (e) => {
          reject(listArcticle)
        }
      })
    });
  }

  public getListArticlesByLedger(data: any): Promise<any> {
    let listArcticle = [];
    return new Promise<any>((resolve, reject) => {
      this.getArticlesByLedgers(data, {
        success: (response) => {
          listArcticle = response.data.map((item) => {
            const itemNew = Object.assign({}, item)
            itemNew.id =  item.article_id;
            itemNew.name = item.article;
            return itemNew
          });
          resolve(listArcticle)
        },
        error: (e) => {
          reject(listArcticle)
        }
      })
    });
  }

  public getListYearsByArticle(ledger: any): Promise<any> {
    let listYears = [];
    return new Promise<any>((resolve, reject) => {
      this.getYearsByArticle(ledger, {
        success: (response) => {
          listYears = response.data.map((item) => {
            const itemNew = Object.assign({}, item)
            itemNew.id =  item.year;
            itemNew.name = item.year;
            return itemNew
          });
          resolve(listYears)
        },
        error: (e) => {
          reject(listYears)
        }
      })
    });
  }




}



// WEBPACK FOOTER //
// ./src/app/core/services/magnetic-media-district/magnetic-media-district.service.ts